import { Descope } from '@descope/react-sdk'
import '../App.css'

function AuthFlow({ defaultFlow, theme, borderRounded, event }) {
  return (
    <div className='page authflow'>
      {(
        <div className={borderRounded ? 'page flow-shown': "page flow-shown rounded-top"}>
          <Descope
            flowId={defaultFlow}
            onSuccess={(e) => console.log(e)}
            theme={theme}
            form={event}
            
          />
        </div>
      )}
    </div>
  )
}

export default AuthFlow
